import { CompanyDetailPageComponent } from "@agent-ds/company/pages";
import { JobDetailPageComponent } from "@agent-ds/jobs/pages/job-detail-page/job-detail-page.component";
import { ProgressCreateDialogComponent, ProgressScheduleAdjustDialogComponent, ProgressScreeningRequestNotifyDialogComponent, ProgressSubScreeningRequestNotifyDialogComponent, ProgressSubScreeningScheduleAdjustDialogComponent, ProgressSubScreeningStartDialogComponent } from "@agent-ds/progress/components";
// tslint:disable-next-line:max-line-length
import { BulkProgressChangeDialogComponent } from "@agent-ds/shared/components/bulk-progress-change-dialog/bulk-progress-change-dialog.component";
import { PageScrollTableComponent } from "@agent-ds/shared/components/page-scroll-table/page-scroll-table.component";
import { getProgressStatusLabel, getSeminarTypeLabel, NULL_SELECTED_VALUE, PROGRESS_ACTION_CODES, PROGRESS_BULK_EDIT, PROGRESS_STATUSES, RESUME_REQUIRED_ON_RECOMMEND_VALUE, SEMINAR_TYPE } from "@agent-ds/shared/constants";
import { PROGRESS_SUB_SCREENING_STATUS_CODE_LABEL_MAPPING, ProgressActionColor, ProgressActionType, ProgressScreeningRequestStatusRequestNoEnum, ProgressScreeningRequestStatusRequestStatusEnum, ProgressStatusCode, ProgressSubScreeningStatusCodes, } from "@agent-ds/shared/enums";
import { EnterpriseDepartmentUserType, SCREENING_INFO_REQUEST_DEADLINE_OPTIONS } from "@agent-ds/shared/interfaces";
import { CacheInterceptor } from "@agent-ds/shared/interceptors/cache.interceptor";
import { RefreshEvent } from "@agent-ds/shared/models";
import { SafeDatePipe } from "@agent-ds/shared/pipes/safe-date.pipe";
import { AuthService, CustomerExpectedCompanyYomiService, DialogService, DynamicFieldService, JobApiService, MailApiService, StudentApiService } from "@agent-ds/shared/services";
import { MasterApiService } from "@agent-ds/shared/services/api/master-api.service";
import { ProgressApiService } from "@agent-ds/shared/services/api/progress-api.service";
import { UserApiService } from "@agent-ds/shared/services/api/user-api.service";
import { cleanObject, deepClone, formatTemplateMultilineValue, getValueFromObject } from "@agent-ds/shared/util/util";
import { StudentDetailPageComponent } from "@agent-ds/student/pages";
import { Location } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, Type } from "@angular/core";
import { Router } from "@angular/router";
import { EMPTY, forkJoin, of } from "rxjs";
import { catchError, concatMap, map, mergeMap, tap } from "rxjs/operators";
import { ProgressDetailComponent } from "../../../progress/pages/progress-detail/progress-detail.component";
import { ConfirmDialogConfig } from "../confirm-dialog/confirm-dialog-config";
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";
import { MailSendFlowComponent } from "../mail-send-flow/mail-send-flow.component";
import { ProgressBulkConfig } from "../mail-send/configs/progress-bulk-config";
import { ProgressConsultConfig } from "../mail-send/configs/progress-consult-config";
import { ProgressInrowJobPostingConfig } from "../mail-send/configs/progress-inrow-job-posting-config";
import { ProgressJobPostingConfig } from "../mail-send/configs/progress-job-posting-config";
import { ProgressNgEndConfig } from "../mail-send/configs/progress-ng-end-config";
import { ProgressOfferConfig } from "../mail-send/configs/progress-offer-config";
import { ProgressRecommendConfig } from "../mail-send/configs/progress-recommend-config";
import { ProgressSendInterviewInfoConfig } from "../mail-send/configs/progress-send-interview-info-config";
import { ProgressSendResumeConfig } from "../mail-send/configs/progress-send-resume-config";
import { PopupControlComponent } from "../popup-control/popup-control.component";
import { ProgressSeminarScheduleLinkDialogComponent } from "../progress-seminar-schedule-link-dialog/progress-seminar-schedule-link-dialog.component";
import { SelectComponent } from "../select/select.component";
import { PROGRESS_LIST_TABLE_CONFIG } from "./progress-list-table-config";
import { ProgressSendSubScreeningInfoConfig } from "../mail-send/configs/progress-send-sub-screening-info-config";
import * as moment from "moment";
import * as _ from "underscore";
export class ProgressListComponent {
    constructor(masterApiService, userApiService, progressApiService, jobApiService, datePipe, cdr, dialog, location, dynamicService, studentApiService, mailApiService, authService, router, expectedCompanyYomiService) {
        this.masterApiService = masterApiService;
        this.userApiService = userApiService;
        this.progressApiService = progressApiService;
        this.jobApiService = jobApiService;
        this.datePipe = datePipe;
        this.cdr = cdr;
        this.dialog = dialog;
        this.location = location;
        this.dynamicService = dynamicService;
        this.studentApiService = studentApiService;
        this.mailApiService = mailApiService;
        this.authService = authService;
        this.router = router;
        this.expectedCompanyYomiService = expectedCompanyYomiService;
        this.requestObject = { status: [] };
        this.disableDetailFullScreen = false;
        this.disableBulkUpdateButton = false;
        this.enableSeminarScheduleLinkButton = false;
        this.statusFilterChange = new EventEmitter();
        this.errorGetList = new EventEmitter();
        this.initialized = false;
        this.ProgressActionType = ProgressActionType;
        this.ProgressActionColor = ProgressActionColor;
        this.ProgressStatusCode = ProgressStatusCode;
        this.getStatusLabel = getProgressStatusLabel;
        this.offerConfig = new ProgressOfferConfig();
        this.consultConfig = new ProgressConsultConfig();
        this.bulkConfig = new ProgressBulkConfig();
        this.recommendConfig = new ProgressRecommendConfig();
        this.ngEndConfig = new ProgressNgEndConfig();
        this.ProgressSendInterviewInfoConfig = ProgressSendInterviewInfoConfig;
        this.ProgressSendSubScreeningInfoConfig = ProgressSendSubScreeningInfoConfig;
        this.PROGRESS_STATUSES = PROGRESS_STATUSES;
        this.canBulkEdit = false;
        this.canSeminarScheduleLink = false;
        this.progressTypeSelectOptions = [
            { label: NULL_SELECTED_VALUE, value: undefined },
            { label: "AG", value: 0 },
            { label: "Plus", value: 1 }
        ];
        this.progressStatusCodesSelectOptions = Object.keys(PROGRESS_STATUSES)
            .filter(code => +code !== 210 && +code < 500)
            .map(statusCode => {
            const code = +statusCode;
            if (code === 100) {
                return [
                    { label: "1次面接設定中", value: 503 },
                    { label: "2次以降面接設定中", value: 506 }
                    // { label: '最終前面接設定中', value: 510 },
                    // { label: '最終面接設定中', value: 520 },
                ];
            }
            else if (code === 110) {
                return [
                    { label: "1次面接確認中", value: 504 },
                    { label: "2次以降面接確認中", value: 507 },
                    { label: "最終前面接確認中", value: 511 },
                    { label: "最終面接確認中", value: 521 }
                ];
            }
            else if (code === 120) {
                return [
                    { label: "1次面接結果待ち", value: 505 },
                    { label: "2次以降面接結果待ち", value: 508 },
                    { label: "最終前面接結果待ち", value: 512 },
                    { label: "最終面接結果待ち", value: 522 }
                ];
            }
            return {
                label: PROGRESS_STATUSES[statusCode].label,
                value: code
            };
        })
            .flatten();
        this.eventEditors = {};
        this.subStatusEventEditors = {};
        this.remarkEditors = {};
        this.stopReasonEditors = {};
        this.editorMeta = {};
        this.subStatusEditorMeta = {};
        this.ckeckJobUsersInProgress = false;
        this.jobUserChecks = null;
        this.alertDropdownStates = {};
        this.loadProgress = (page, pageSize, sortingField, sortingOrder) => {
            return this.progressApiService
                .getList(cleanObject(Object.assign({}, this.requestObject, { status: this.requestObject ? this.requestObject.status || [] : [], sort: sortingField, order: sortingOrder, from: page * pageSize, size: pageSize })))
                .pipe(map((resp) => {
                this.progresses = (this.progresses || [])
                    .concat(resp.progresses)
                    .filter((p, i, self) => self.findIndex(x => x.id === p.id) === i);
                return {
                    result: resp.progresses,
                    totalSize: resp.total ? resp.total : 0
                };
            }), catchError((error) => {
                // ネットワークに繋がらなかったときはエラーを通知する
                this.errorGetList.emit(error);
                return EMPTY;
            }));
        };
    }
    get hasCheckedItems() {
        return this.table && this.table.hasCheckedItems;
    }
    ngOnInit() {
        this.refreshSubscription = this.progressApiService.refreshEvent.subscribe(() => this.refreshData(true, true));
        this.checkRoute();
        this.dateTime = this.dynamicService.getFormRows({
            fieldType: "date",
            fieldName: "seminarAt",
            displayType: "date+time"
        })[0];
        this.dateTime.fields.push({
            type: "radio",
            name: "seminarType",
            labelField: "label",
            valueField: "value",
            options: [
                { label: NULL_SELECTED_VALUE, value: 1 },
                { label: "最終前面接", value: 99 },
                { label: "最終面接", value: 100 }
            ]
        });
        this.baseEditorMeta = {
            groups: [
                {
                    class: "no-title-column no-border no-background",
                    rows: [this.dateTime]
                }
            ]
        };
        const subStatusDateFormRow = this.dynamicService.getFormRows({
            fieldType: "date",
            fieldName: "scheduledAt",
            displayType: "date+time"
        })[0];
        this.baseSubStatusEditorMeta = {
            groups: [
                {
                    class: "no-title-column no-border no-background",
                    rows: [
                        subStatusDateFormRow
                    ]
                }
            ]
        };
    }
    ngOnChanges(changes) {
        if (changes &&
            changes["student"] != null &&
            changes["student"].previousValue !== changes["student"].currentValue &&
            this.progressStatusSelect) {
            this.progressStatusSelect.selectAll();
        }
        if (!changes ||
            (changes["requestObject"] &&
                changes["requestObject"].previousValue !==
                    changes["requestObject"].currentValue)) {
            [...Object.keys(this.eventEditors), ...Object.keys(this.remarkEditors)]
                .removeSame()
                .forEach(key => this.onCancelClick(+key));
            if (this.table && this.initialized) {
                this.refreshData();
            }
        }
    }
    ngAfterViewInit() {
        this.tableConfig = PROGRESS_LIST_TABLE_CONFIG(this.statusTemplate, this.applicantTemplate, this.applicantContactTemplate, this.cellArrowTemplate, this.jobTemplate, this.jobContactTemplate, this.actionsTemplate, this.raExpectedContractMonthSectionTemplate, date => this.datePipe.transform(date, "yyyy/MM/dd (E) HH:mm"));
        this.cdr.detectChanges();
        this.initialized = true;
        if (this.requestObject && this.table) {
            this.refreshData(true);
        }
        if (this.table) {
            this.itemCheckedSubscription = this.table.itemChecked.subscribe(() => {
                this.computeCanBulkEdit();
                this.computeCanSeminarScheduleLink();
            });
        }
    }
    ngOnDestroy() {
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
        if (this.itemCheckedSubscription) {
            this.itemCheckedSubscription.unsubscribe();
        }
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }
    showStudentDelayBtn(status) {
        return status === 70 || status === 90 || status === 100;
    }
    showSeminarDate(status) {
        return status === 80 || status === 90 || status === 110 || status === 120;
    }
    showEnterpriseDocReceivedDate(status) {
        return status === 60;
    }
    showOfferedDate(status) {
        return status === 130 || status === 140;
    }
    showInvoiceReceivedDate(status) {
        return status === 150;
    }
    showInvoiceProcessedDate(status) {
        return status === 160;
    }
    getContactUser(userId) {
        return userId != null
            ? this.userApiService
                .getAll()
                .pipe(map((users) => users.find(user => user.id === userId)))
            : of(null);
    }
    getContactTeamName(userId) {
        return this.getContactUser(userId).pipe(concatMap((user) => user ? this.getTeamNameForUser(user) : of(null)));
    }
    getJobContactUser(jobUsers, type) {
        const jobUserType = type === 0
            ? EnterpriseDepartmentUserType.RA
            : type === 1
                ? EnterpriseDepartmentUserType.PA
                : null;
        const jobUser = jobUsers && jobUsers.length
            ? jobUsers.find(user => user.enterpriseDepartmentUser.type === jobUserType)
            : null;
        return jobUser &&
            jobUser.enterpriseDepartmentUser &&
            jobUser.enterpriseDepartmentUser.userId != null
            ? this.getContactUser(jobUser.enterpriseDepartmentUser.userId)
            : of(null);
    }
    getJobContactTeamName(jobUsers, type) {
        return this.getJobContactUser(jobUsers, type).pipe(concatMap((user) => user ? this.getTeamNameForUser(user) : of(null)));
    }
    getTeamNameForUser(user) {
        return this.masterApiService.getTeams().pipe(map((teams) => {
            const foundTeam = teams.find(team => team.id === user.teamId);
            return foundTeam ? foundTeam.name : "";
        }));
    }
    onProgressSelect(progress) {
        ProgressDetailComponent.instance.disableFullScreen = this.disableDetailFullScreen;
        ProgressDetailComponent.instance.referenceId = progress
            ? progress.id
            : null;
        ProgressDetailComponent.instance.open();
        this.cdr.detectChanges();
    }
    onProgressFilterChange() {
        this.statusFilterChange.emit();
        this.refreshData();
    }
    onStudentDelayClick(progress, event) {
        event.stopPropagation();
        this.progressApiService
            .updateWithoutAction(progress.id, {
            type: progress.type,
            hasInterview: progress.hasInterview,
            n: progress.n,
            seminarType: progress.seminarType,
            isStudentDelay: progress.isStudentDelay > 0 ? 0 : 1,
            seminarAt: progress.seminarAt,
            dynamicData: progress.dynamicData
        })
            .subscribe(() => {
            progress.isStudentDelay = progress.isStudentDelay > 0 ? 0 : 1;
            this.progressApiService.refreshEvent.emit();
        });
    }
    onProgressActionClick(progress, action) {
        if (!progress || !action) {
            return;
        }
        // requiresResume が付いたアクション（遷移先に 40 を含むもの）だけがこのチェックを通る。
        // それ以外のアクションは従来どおり素通りして下の switch に進む
        if (action.requiresResume && this.isRecommendBlockedByResume(progress)) {
            this.openResumeRequiredDialog();
            return;
        }
        switch (action.type) {
            case ProgressActionType.DELETE:
                this.onDeleteActionClick(progress.id);
                break;
            case ProgressActionType.DIALOG:
                this.onDialogActionClick(progress, action.dialog, action.id);
                break;
            case ProgressActionType.EDITOR:
                this.onEditorActionClick(progress.id, action.request ? action.request(progress, action.baseRequest) : null, action.seminarValues);
                break;
            case ProgressActionType.MAIL:
                this.onMailActionClick(progress, action.mailConfig);
                break;
            case ProgressActionType.OPERATION:
                this.onOperationActionClick(progress.id, action.request ? action.request(progress, action.baseRequest) : null);
                break;
            default:
                return;
        }
    }
    onMailActionClick(progress, mailConfig) {
        if (!mailConfig) {
            return;
        }
        const mailConfigInstance = new mailConfig();
        const progressObj = {};
        if (progress) {
            if (this.eventEditors[progress.id]) {
                progressObj.progressSeminarAt =
                    new Date(this.eventEditors[progress.id].seminarAt).toAsialDateTimeString() || progress.seminarAt;
                progressObj.progressSeminarType = this.eventEditors[progress.id].seminarType;
            }
            else {
                progressObj.progressSeminarAt = progress.seminarAt;
                progressObj.progressSeminarType = progress.seminarType;
            }
            progressObj.progressId = progress.id;
            progressObj.progressN = progress.n;
            progressObj.progressHasInterview = progress.hasInterview;
            progressObj.progressSeminarAtMailSendFlag = 1;
            progressObj.progressIsStudentDelay = progress.isStudentDelay;
            progressObj.progressType = progress.type;
            progressObj.progressStatus = progress.status;
        }
        if (mailConfigInstance instanceof ProgressRecommendConfig) {
            this.openMail(mailConfigInstance, progress, true);
        }
        else if (mailConfigInstance instanceof ProgressInrowJobPostingConfig ||
            mailConfigInstance instanceof ProgressJobPostingConfig) {
            forkJoin(this.studentApiService.getSuggestions(undefined, [progress.studentId]), this.jobApiService.getSuggestions(undefined, [progress.jobId])).subscribe(([students, jobs]) => {
                MailSendFlowComponent.instance.config = mailConfigInstance;
                mailConfigInstance.setParams(Object.assign({ students: students, jobs: jobs }, progressObj));
                MailSendFlowComponent.instance.start();
                const sentSub = MailSendFlowComponent.instance.sent.subscribe(() => {
                    this.refreshData(true, true);
                    if (progress && this.eventEditors[progress.id]) {
                        this.eventEditors[progress.id] = null;
                    }
                    sentSub.unsubscribe();
                });
                const closedSub = MailSendFlowComponent.instance.closed.subscribe(() => {
                    sentSub.unsubscribe();
                    closedSub.unsubscribe();
                });
            });
        }
        else if (mailConfigInstance instanceof ProgressSendInterviewInfoConfig) {
            this.progressApiService
                .getStakeholders([progress.id])
                .subscribe((stakeholders) => {
                if (stakeholders.length) {
                    MailSendFlowComponent.instance.config = mailConfigInstance;
                    const settingStatus = [
                        ProgressStatusCode.セミナー設定中,
                        ProgressStatusCode.面接設定中
                    ].includes(progress.status);
                    const confirmStatus = [
                        ProgressStatusCode.セミナー確認中,
                        ProgressStatusCode.面接確認中
                    ].includes(progress.status);
                    const progressUpdateRequest = settingStatus
                        ? this.buildSendInterviewInfoUpdateRequest(progress, progressObj)
                        : confirmStatus
                            ? this.buildConfirmInterviewInfoUpdateRequest(progress, progressObj)
                            : null;
                    mailConfigInstance.setParams(Object.assign({ stakeholders: stakeholders[0], progressType: progress.type, studentId: progress.studentId, jobId: progress.jobId, enterpriseId: progress.enterprise.id, progressUpdateRequest }, progressObj));
                    MailSendFlowComponent.instance.start();
                    if (settingStatus || confirmStatus) {
                        const sub = MailSendFlowComponent.instance.sent.subscribe(() => {
                            this.progressApiService.refreshEvent.emit();
                            if (progress && this.eventEditors[progress.id]) {
                                this.eventEditors[progress.id] = null;
                            }
                            sub.unsubscribe();
                        });
                        const closedSub = MailSendFlowComponent.instance.closed.subscribe(() => {
                            sub.unsubscribe();
                            closedSub.unsubscribe();
                        });
                    }
                }
            });
        }
        else if (mailConfigInstance instanceof ProgressSendResumeConfig) {
            if (this.authService.authInfo.zone !== "zone3") {
                PopupControlComponent.instance.open({
                    title: null,
                    content: "ZONE3専用です。",
                    confirmText: "OK",
                    confirmCallback: () => false
                });
                return;
            }
            forkJoin(this.studentApiService.getSuggestions(undefined, [progress.studentId]), this.jobApiService.getSuggestions(undefined, [progress.jobId]), this.jobApiService.ckeckJobUsers([progress.jobId])).subscribe(([students, jobs, checkedJobs]) => {
                MailSendFlowComponent.instance.config = mailConfigInstance;
                mailConfigInstance.setParams(Object.assign({ student: students.length ? students[0] : [], enterpriseId: progress.enterprise.id, jobs: [Object.assign({}, jobs[0], { jobUsers: checkedJobs[0].jobUsers })] }, progressObj));
                MailSendFlowComponent.instance.start();
                const sentSub = MailSendFlowComponent.instance.sent.subscribe(() => {
                    this.refreshData(true, true);
                    if (progress && this.eventEditors[progress.id]) {
                        this.eventEditors[progress.id] = null;
                    }
                    sentSub.unsubscribe();
                });
                const closedSub = MailSendFlowComponent.instance.closed.subscribe(() => {
                    sentSub.unsubscribe();
                    closedSub.unsubscribe();
                });
            });
        }
    }
    getYearMonthFromDateString(dateString) {
        return this.expectedCompanyYomiService.getYearMonthFromDateString(dateString);
    }
    handleUpdateRaExpectedContractMonth($event, progress) {
        this.expectedCompanyYomiService
            .handleUpdateRaExpectedContractMonth($event.target.value, progress)
            .subscribe((res) => this.progressApiService.refreshEvent.emit());
    }
    onEditorActionClick(progressId, requestObject, seminarValues) {
        if (!requestObject) {
            return;
        }
        const progress = this.progresses.find((p) => p.id === progressId);
        this.onSubStatusCancelClick(progress);
        if (seminarValues) {
            this.editorMeta[progressId] = deepClone(this.baseEditorMeta);
            this.editorMeta[progressId].groups[0].rows[0].fields.last().options = seminarValues;
        }
        else {
            this.editorMeta[progressId] = this.baseEditorMeta;
        }
        this.eventEditors[progressId] = {
            seminarAt: this.datePipe.transform(new Date(), "yyyy/MM/dd"),
            seminarType: 1,
            seminarAtMailSendFlag: false,
            requestObject: requestObject,
            inSave: false
        };
    }
    onOperationActionClick(progressId, requestObject) {
        if (!requestObject) {
            return;
        }
        this.progressApiService
            .updateWithAction(progressId, requestObject)
            .subscribe((resp) => {
            // this.refreshData(true, true);
            this.progressApiService.refreshEvent.emit();
        });
    }
    /**
     * 「営業書類結果待ち」への遷移が履歴書未提出により不可かを判定する。
     * mach-api の ProgressService.isRecommendBlockedByResume() と同じ判定にすること。
     * 片方だけ変えると、API は許可するのに画面がボタンを殺す（またはその逆）状態になる。
     */
    isRecommendBlockedByResume(progress) {
        const required = progress.job && progress.job.dynamicData ? progress.job.dynamicData.resumeRequiredOnRecommend : null;
        if (!Array.isArray(required) || required.indexOf(RESUME_REQUIRED_ON_RECOMMEND_VALUE) < 0) {
            return false;
        }
        if (!progress.student || !progress.student.dynamicData) {
            return false;
        }
        const status = progress.student.dynamicData.documentSubmissionStatus;
        return status === null || status === undefined || status === '';
    }
    createResumeRequiredDialogConfig() {
        return {
            title: '推薦OK状態ではありません。',
            messages: ['履歴書が未提出または未確認のため、「営業書類結果待ち」にできません。'],
            buttons: { yes: 'OK', no: '', hideNo: true },
        };
    }
    openResumeRequiredDialog() {
        this.dialog.open(ConfirmDialogComponent, this.createResumeRequiredDialogConfig());
    }
    onDialogActionClick(progress, dialog, actionId) {
        if (!dialog) {
            return;
        }
        let dataObj = {};
        if (actionId === 140) {
            this.progressApiService.getContractInfo(progress.id).subscribe(info => {
                if (info.approvedContractIds.length &&
                    info.enterpriseBillingAddressIds.length) {
                    dataObj = {
                        progressId: progress.id,
                        enterpriseId: progress.enterprise.id,
                        progressType: progress.type,
                        jobUsers: progress.job.jobUsers,
                        caUserId: progress.student.caUserId
                    };
                    const dRef = this.dialog.open(dialog, { data: dataObj });
                    const dCloseSubscription = dRef.afterClosed.subscribe(res => {
                        if (res) {
                            this.refreshData(true, true);
                        }
                        dCloseSubscription.unsubscribe();
                    });
                }
                else {
                    PopupControlComponent.instance.open({
                        title: "必要な情報が入力されていません",
                        content: "承認済みの契約が登録されていないか、\n請求先が登録されていません。",
                        confirmText: "閉じる",
                        confirmCallback: () => false
                    });
                }
            });
            return;
        }
        else if (actionId === 74) {
            dataObj = {
                studentIds: [progress.studentId],
                jobId: progress.jobId,
                progressStatus: progress.status,
                progressN: progress.n,
                progressIds: [progress.id],
                progressType: progress.type,
                title: dialog === ProgressScheduleAdjustDialogComponent
                    ? "求職者へ日程調整送信"
                    : null,
                enterpriseId: progress.enterprise.id
            };
        }
        const dialogRef = this.dialog.open(dialog, { data: dataObj });
        const dialogCloseSubscription = dialogRef.afterClosed.subscribe(res => {
            if (res) {
                this.refreshData(true, true);
            }
            dialogCloseSubscription.unsubscribe();
        });
    }
    onDeleteActionClick(progressId) {
        this.progressApiService
            .delete(progressId)
            .subscribe(() => this.progressApiService.refreshEvent.emit(RefreshEvent.DELETE));
    }
    onSaveClick(progress) {
        if (this.eventEditors[progress.id] &&
            this.eventEditors[progress.id].inSave) {
            return;
        }
        let eventRequestObject = null;
        let remarksRequestObject = null;
        let remarksRequest = null;
        let eventRequest = null;
        if (this.remarkEditors[progress.id]) {
            const remarks = this.remarkEditors[progress.id].remarks || "";
            remarksRequestObject = { remarks: remarks };
            remarksRequest = this.progressApiService.updateHistoryRemarks(progress.id, progress.latestRevision, remarksRequestObject);
        }
        if (this.eventEditors[progress.id]) {
            this.eventEditors[progress.id].inSave = true;
            const event = this.eventEditors[progress.id];
            if (event.requestObject && event.seminarAt) {
                const seminarAtStr = new Date(event.seminarAt).toAsialDateTimeString();
                eventRequestObject = Object.assign({}, event.requestObject, {
                    seminarAt: seminarAtStr,
                    seminarType: event.seminarType || 1,
                    seminarAtMailSendFlag: event.seminarAtMailSendFlag ? 0 : 1
                });
                if (progress.status === 70) {
                    if (eventRequestObject.seminarType === 1) {
                        eventRequestObject.seminarType = 0;
                        eventRequestObject.action = 72;
                        eventRequestObject.n = progress.n;
                    }
                    else if (eventRequestObject.seminarType === 99 ||
                        eventRequestObject.seminarType === 100) {
                        eventRequestObject.action = 74;
                        eventRequestObject.n = (progress.n || 0) + 1;
                    }
                }
                const newPhaseName = eventRequestObject.seminarType === 0
                    ? 'セミナー'
                    : getSeminarTypeLabel('面接', eventRequestObject.seminarType, eventRequestObject.n);
                eventRequest = this.progressApiService.updateWithAction(progress.id, eventRequestObject).pipe(concatMap(() => {
                    return this.progressApiService.updateScreeningRequestDeadlines(progress.id, seminarAtStr);
                }), concatMap(() => {
                    return this.progressApiService.syncMainScreeningRequestType(progress.id, newPhaseName);
                }));
                if (remarksRequest) {
                    remarksRequest = this.progressApiService.updateHistoryRemarks(progress.id, (progress.latestRevision || 0) + 1, remarksRequestObject);
                }
            }
            if (!event.seminarAtMailSendFlag) {
                this.progressApiService.getStakeholders([progress.id]).subscribe((stakeholders) => {
                    const stakeholder = stakeholders && stakeholders.length ? stakeholders[0] : null;
                    if (stakeholders &&
                        stakeholder.studentInfo.mainAvailable === "不可") {
                        PopupControlComponent.instance.open({
                            title: "エラー",
                            content: "E-MAIL(メイン)が「送信不可」です。",
                            confirmText: "閉じる",
                            confirmCallback: () => {
                                this.eventEditors[progress.id].inSave = false;
                            }
                        });
                    }
                    else if (stakeholder) {
                        this.mailApiService
                            .getMailTemplates()
                            .pipe(map((templates) => templates.find(template => template.id ===
                            (progress.type === 0
                                ? 14
                                : progress.type === 1
                                    ? 19
                                    : -1))))
                            .subscribe((template) => {
                            if (template) {
                                const mailRequestObject = {
                                    to: stakeholder.studentInfo.mainAvailable !== "不可"
                                        ? [stakeholder.studentInfo.main]
                                        : null,
                                    cc: [
                                        stakeholder.studentInfo.subAvailable !== "不可"
                                            ? stakeholder.studentInfo.sub
                                            : null,
                                        ...stakeholder.jobUsersInfo
                                            .filter(jobUser => jobUser.type === 0)
                                            .map(jobUser => jobUser.email)
                                    ].filter(v => v),
                                    bcc: [
                                        ...stakeholder.jobUsersInfo
                                            .filter(jobUser => jobUser.type ===
                                            (progress.type === 0
                                                ? EnterpriseDepartmentUserType.RA
                                                : progress.type === 1
                                                    ? EnterpriseDepartmentUserType.PA
                                                    : -1))
                                            .map(jobUser => jobUser.email)
                                    ].filter(v => v),
                                    userId: this.authService.loginUser.id,
                                    from: this.authService.loginUser.email,
                                    subject: template.subject,
                                    text: template.body,
                                    templateTypeId: 8,
                                    jobId: progress.jobId
                                };
                                const mailRequest = this.mailApiService
                                    .replaceTemplate(mailRequestObject.templateTypeId, {
                                    from: mailRequestObject.from,
                                    to: mailRequestObject.to,
                                    subject: mailRequestObject.subject,
                                    text: mailRequestObject.text,
                                    studentId: progress.studentId,
                                    jobId: progress.jobId
                                })
                                    .pipe(mergeMap(res => {
                                    mailRequestObject.subject = res.subject;
                                    mailRequestObject.text = res.body;
                                    return this.mailApiService.sendStudentMail(progress.studentId, mailRequestObject);
                                }));
                                if (eventRequest && remarksRequest) {
                                    eventRequest = eventRequest.pipe(mergeMap(() => remarksRequest.pipe(mergeMap(() => mailRequest))));
                                }
                                else if (remarksRequest) {
                                    eventRequest = remarksRequest.pipe(mergeMap(() => mailRequest));
                                }
                                else {
                                    eventRequest = eventRequest.pipe(mergeMap(() => mailRequest));
                                }
                                /* node 22 対応 */
                                this.doMailSubscribe(eventRequest);
                                setTimeout(() => {
                                    // this.refreshData(true, true);
                                    this.eventEditors[progress.id].inSave = false;
                                    this.onCancelClick(progress.id);
                                    PopupControlComponent.instance.open({
                                        title: "メール送信処理開始",
                                        content: "メール送信処理を開始しました。\nしばらく経ってからメール管理画面へ反映されます。\n\nもしメール送信が失敗した場合、メール送信失敗メールが届きます。",
                                        confirmText: "OK",
                                        confirmCallback: () => false
                                    });
                                    CacheInterceptor.requestCountChange.emit(0);
                                }, 10);
                                setTimeout(() => {
                                    CacheInterceptor.requestCountChange.emit(0);
                                }, 1000);
                                /*
                                eventRequest.subscribe(
                                  () => {
                                    this.refreshData(true, true);
                                    this.eventEditors[progress.id].inSave = false;
                                    this.onCancelClick(progress.id);
                                  },
                                  () => {
                                    this.eventEditors[progress.id].inSave = false;
                                  },
                                );
                                */
                            }
                            else {
                                this.eventEditors[progress.id].inSave = false;
                            }
                        }, () => {
                            this.eventEditors[progress.id].inSave = false;
                        });
                    }
                    else {
                        this.eventEditors[progress.id].inSave = false;
                    }
                }, () => {
                    this.eventEditors[progress.id].inSave = false;
                });
            }
            else if (eventRequest || remarksRequest) {
                if (eventRequest && remarksRequest) {
                    eventRequest = eventRequest.pipe(mergeMap(() => remarksRequest));
                }
                else if (remarksRequest) {
                    eventRequest = remarksRequest;
                }
                eventRequest.subscribe(() => {
                    // this.refreshData(true, true);
                    this.progressApiService.refreshEvent.emit();
                    this.eventEditors[progress.id].inSave = false;
                    this.onCancelClick(progress.id);
                });
            }
            else {
                this.eventEditors[progress.id].inSave = false;
            }
        }
        else {
            remarksRequest.subscribe(() => {
                this.refreshData(true, true);
                this.onCancelClick(progress.id);
            });
        }
    }
    doMailSubscribe(doMail) {
        doMail.subscribe();
    }
    onStopReasonSaveClick(progress) {
        if (!this.stopReasonEditors[progress.id]) {
            this.onCancelClick(progress.id);
            return;
        }
        const stopReasonText = this.stopReasonEditors[progress.id].stopReason || "";
        this.progressApiService
            .updateWithoutAction(progress.id, {
            type: progress.type,
            hasInterview: progress.hasInterview,
            n: progress.n,
            seminarType: progress.seminarType,
            seminarAt: progress.seminarAt != null
                ? new Date(progress.seminarAt).toAsialDateTimeString()
                : null,
            isStudentDelay: progress.isStudentDelay,
            dynamicData: Object.assign({}, progress.dynamicData, { stopReason: stopReasonText })
        })
            .subscribe(() => {
            this.refreshData(true, true);
            this.onCancelClick(progress.id);
        }, (error) => {
            const dialogConfig = ConfirmDialogConfig.createErrorDialog(error);
            this.dialog.open(ConfirmDialogComponent, dialogConfig);
        });
    }
    onCancelClick(progressId) {
        if (this.eventEditors[progressId]) {
            delete this.eventEditors[progressId];
        }
        if (this.remarkEditors[progressId]) {
            delete this.remarkEditors[progressId];
        }
        if (this.stopReasonEditors[progressId]) {
            delete this.stopReasonEditors[progressId];
        }
    }
    editRemarks(progressId, remarks) {
        this.remarkEditors[progressId] = {
            remarks: remarks,
            edit: true,
            show: true
        };
    }
    toggleRemarksDisplay(progressId) {
        if (!this.remarkEditors[progressId]) {
            this.remarkEditors[progressId] = {
                remarks: "",
                edit: false,
                show: true
            };
            return;
        }
        this.remarkEditors[progressId].show = !this.remarkEditors[progressId].show;
    }
    editStopReason(progressId, stopReason) {
        this.stopReasonEditors[progressId] = {
            stopReason: stopReason,
            edit: true,
            show: true
        };
    }
    toggleStopReasonDisplay(progressId) {
        if (!this.stopReasonEditors[progressId]) {
            this.stopReasonEditors[progressId] = {
                stopReason: "",
                edit: false,
                show: true
            };
            return;
        }
        this.stopReasonEditors[progressId].show = !this.stopReasonEditors[progressId].show;
    }
    refreshData(dataOnly, noScroll) {
        this.progresses = [];
        this.table.reset(dataOnly, noScroll);
        this.table.next();
        this.computeCanBulkEdit();
        this.computeCanSeminarScheduleLink();
    }
    isValidSelectedItemsForBulkScheduleAdjust() {
        const selectedProgresses = this.table && this.table.checkedItems;
        if (!selectedProgresses || !selectedProgresses.length) {
            return false;
        }
        if (selectedProgresses.length === 1 &&
            (selectedProgresses[0].status === 70 ||
                selectedProgresses[0].status === 100)) {
            return true;
        }
        const isJobIdSame = selectedProgresses
            .map((progress) => progress.jobId)
            .every(jobId => jobId === selectedProgresses[0].jobId);
        const isStatusSame = selectedProgresses
            .map((progress) => progress.status)
            .every(status => status === selectedProgresses[0].status &&
            (selectedProgresses[0].status === 70 ||
                selectedProgresses[0].status === 100));
        let isNSame = true;
        if (selectedProgresses[0].status === 100) {
            isNSame = selectedProgresses
                .map((progress) => progress.n)
                .every(n => n === selectedProgresses[0].n);
        }
        return isJobIdSame && isStatusSame && isNSame;
    }
    openProgressBulkScheduleAdjustDialog() {
        if (!this.isValidSelectedItemsForBulkScheduleAdjust()) {
            return;
        }
        const selectedProgresses = this.table && this.table.checkedItems;
        if (!selectedProgresses || !selectedProgresses.length) {
            return;
        }
        const dialogRef = this.dialog.open(ProgressScheduleAdjustDialogComponent, {
            data: {
                studentIds: selectedProgresses.map(progress => progress.studentId),
                jobId: selectedProgresses[0].jobId,
                progressStatus: selectedProgresses[0].status,
                progressN: selectedProgresses[0].n,
                progressSeminarType: selectedProgresses[0].seminarType,
                progressIds: selectedProgresses.map(progress => progress.id),
                progressType: selectedProgresses[0].type,
                enterpriseId: selectedProgresses[0].enterprise.id
            }
        });
        const dialogCloseSubscription = dialogRef.afterClosed.subscribe(res => {
            if (res) {
                this.refreshData(true, true);
            }
            dialogCloseSubscription.unsubscribe();
        });
    }
    openSeminarScheduleLinkDialog() {
        if (!this.canSeminarScheduleLink) {
            return;
        }
        const checkedItems = this.table.checkedItems;
        if (!checkedItems || !checkedItems.length) {
            return;
        }
        const matchedScheduleList = this.getMatchedSeminarScheduleList();
        if (!matchedScheduleList || !matchedScheduleList.length) {
            return;
        }
        this.dialog.open(ProgressSeminarScheduleLinkDialogComponent, {
            data: {
                schedules: matchedScheduleList
            }
        }, (result) => {
            if (!result || !result.jobSettingSeminarScheduleId) {
                return;
            }
            const progressIds = checkedItems.map(item => item.id);
            return this.progressApiService
                .bulkSeminarSchedule(progressIds, result.jobSettingSeminarScheduleId)
                .pipe(tap(() => this.progressApiService.refreshEvent.emit()));
        });
    }
    openProgressBulkDeclineDialog() {
        if (!this.hasCheckedItems) {
            return;
        }
        const config = {
            title: "一括辞退",
            messages: ["一括辞退をしてもよろしいですか"],
            style: {
                height: "245px",
                width: "600px"
            },
            buttons: {
                no: "キャンセル",
                yes: "OK"
            }
        };
        this.dialog.open(ConfirmDialogComponent, config, (result) => {
            if (result) {
                return this.progressApiService
                    .bulkDecline(this.table.checkedItems
                    .map(item => (item && item["id"] ? item["id"] : null))
                    .filter(v => v != null))
                    .pipe(tap(() => {
                    // this.refreshData(true, true);
                    this.progressApiService.refreshEvent.emit();
                }));
            }
        });
    }
    openProgressBulkEditDialog() {
        if (!this.checkCanBulkEdit()) {
            return;
        }
        const config = {
            data: {
                options: deepClone(PROGRESS_BULK_EDIT[this.table.checkedItems[0].status])
            }
        };
        this.dialog.open(BulkProgressChangeDialogComponent, config, (result) => {
            if (result) {
                this.openProgressBulkEditConfirmationDialog(result);
            }
        });
    }
    openProgressBulkEditConfirmationDialog(result) {
        const config = {
            title: "一括変更",
            messages: [
                `選択した全ての進捗ステータスを「${result.label(undefined, 1)}」へ一括で変更します。よろしいですか？`
            ],
            style: {
                height: "245px",
                width: "600px"
            },
            buttons: {
                no: "キャンセル",
                yes: "OK"
            }
        };
        this.dialog.open(ConfirmDialogComponent, config, (confirmed) => {
            if (!confirmed) {
                return;
            }
            const progressIds = this.table.checkedItems
                .map(item => (item && item["id"] ? item["id"] : null))
                .filter(v => v != null);
            const request = {
                toStatus: result.toStatus,
                fromStatus: result.fromStatus,
                stopReason: result.stopReason,
                remarks: result.remarks
            };
            return this.progressApiService.bulkEdit(progressIds, request).pipe(tap(() => {
                this.canBulkEdit = false;
                this.refreshData(true, true);
                this.progressApiService.refreshEvent.emit();
            }));
        });
    }
    checkCanBulkEdit() {
        if (!this.hasCheckedItems) {
            return false;
        }
        const status = this.table.checkedItems[0].status;
        return (Object.keys(PROGRESS_BULK_EDIT).includes("" + status) &&
            this.checkedItemsStatusIs(status));
    }
    directTransition(progress, transition) {
        const requestDto = {
            fromStatus: transition.fromStatus,
            toStatus: transition.toStatus,
            remarks: transition.remarks,
            stopReason: transition.stopReason
        };
        const directSubs = this.progressApiService
            .bulkEdit([progress.id], requestDto)
            .subscribe(() => {
            this.refreshData(true, true);
            this.progressApiService.refreshEvent.emit();
            directSubs.unsubscribe();
        });
    }
    checkRoute() {
        if (this.router.url.endsWith("/progresses/add")) {
            this.openProgressCreateDialog();
        }
    }
    checkedItemsStatusIs(status) {
        return this.table
            ? this.table.checkedItems.every(i => i.status === status)
            : false;
    }
    openProgressCreateDialog(origUrl = this.location.path()) {
        if (this.dialogRef) {
            return;
        }
        this.location.go("/progresses/add");
        ProgressDetailComponent.instance.close();
        this.dialogRef = this.dialog.open(ProgressCreateDialogComponent, {
            data: {
                studentId: this.student ? this.student.id : null,
                jobId: this.job ? this.job.id : null,
                enterpriseId: this.requestObject
                    ? this.requestObject.enterpriseId
                    : null
            }
        });
        let closeSubscription;
        let navigationSubscription;
        const unsubscribe = () => {
            if (closeSubscription) {
                closeSubscription.unsubscribe();
            }
            if (navigationSubscription) {
                navigationSubscription.unsubscribe();
            }
        };
        closeSubscription = this.dialogRef.afterClosed.subscribe(() => {
            this.location.go(origUrl);
            this.dialogRef = null;
            unsubscribe();
        });
        navigationSubscription = this.location.subscribe(() => {
            this.dialogRef.close();
            unsubscribe();
        });
    }
    openMail(config, progress, refreshProgressList) {
        const jobIds = [];
        const studentIds = [];
        const enterprises = [];
        const progressIds = [];
        let students = [];
        let jobs = [];
        if (progress) {
            progressIds.push(progress.id);
            jobIds.push(progress.jobId);
            studentIds.push(progress.studentId);
            enterprises.push({
                frontId: progress.enterprise.frontId,
                id: progress.enterprise.id,
                name: progress.enterprise.name
            });
        }
        else {
            this.table.checkedItems.forEach((item) => {
                if (!(config instanceof ProgressNgEndConfig) || item.status === 170) {
                    progressIds.push(item.id);
                    jobIds.push(item.jobId);
                    studentIds.push(item.studentId);
                    enterprises.push({
                        frontId: item.enterprise.frontId,
                        id: item.enterprise.id,
                        name: item.enterprise.name
                    });
                }
            });
        }
        const obs = [];
        if (this.student) {
            students.push({
                id: this.student.id,
                frontId: this.student.frontId,
                emailMain: getValueFromObject(this.student.dynamicData, "emailMain.email"),
                emailMainAvailable: getValueFromObject(this.student.dynamicData, "emailMain.emailAvailable"),
                emailSub: getValueFromObject(this.student.dynamicData, "emailSub.email"),
                emailSubAvailable: getValueFromObject(this.student.dynamicData, "emailSub.emailAvailable"),
                studentUser: this.student.studentUsers,
                firstName: this.student.dynamicData.firstName,
                lastName: this.student.dynamicData.lastName
            });
        }
        else {
            obs.push(this.studentApiService
                .getSuggestions(undefined, studentIds.removeSame())
                .pipe(tap(res => (students = res))));
        }
        if (this.job && !(config instanceof ProgressRecommendConfig)) {
            jobs.push({
                id: this.job.id,
                frontId: this.job.frontId,
                position: getValueFromObject(this.job.dynamicData, "position"),
                enterpriseName: this.job.enterpriseName,
                enterpriseId: this.job.enterpriseId,
                frontEnterpriseId: this.job.frontEnterpriseId,
                enterpriseDepartmentId: this.job.enterpriseDepartmentId,
                jobUsers: this.job.enterpriseDepartmentUsers
            });
        }
        else {
            obs.push(this.jobApiService
                .getSuggestions(undefined, jobIds.removeSame())
                .pipe(tap(res => (jobs = res))));
        }
        const progressObj = {};
        if (progress) {
            if (this.eventEditors[progress.id]) {
                progressObj.progressSeminarAt = new Date(this.eventEditors[progress.id].seminarAt).toAsialDateTimeString();
                progressObj.progressSeminarType = this.eventEditors[progress.id].seminarType;
            }
            else {
                progressObj.progressSeminarAt = progress.seminarAt;
                progressObj.progressSeminarType = progress.seminarType;
            }
            progressObj.progressId = progress.id;
            progressObj.progressN = progress.n;
            progressObj.progressHasInterview = progress.hasInterview;
            progressObj.progressSeminarAtMailSendFlag = 1;
            progressObj.progressIsStudentDelay = progress.isStudentDelay;
            progressObj.progressType = progress.type;
            progressObj.progressStatus = progress.status;
        }
        forkJoin(obs).subscribe(() => {
            MailSendFlowComponent.instance.config = config;
            config.setParams(Object.assign({ progressIds: progressIds, students: students, jobs: jobs, jobId: this.job ? this.job.id : null, enterprises: enterprises.removeSame("id") }, progressObj));
            MailSendFlowComponent.instance.start();
            if (refreshProgressList) {
                const sentSub = MailSendFlowComponent.instance.sent.subscribe(() => {
                    this.refreshData(true, true);
                    if (progress && this.eventEditors[progress.id]) {
                        this.eventEditors[progress.id] = null;
                    }
                    sentSub.unsubscribe();
                });
                const closedSub = MailSendFlowComponent.instance.closed.subscribe(() => {
                    sentSub.unsubscribe();
                    closedSub.unsubscribe();
                });
            }
        });
    }
    onStudentLinkClick(event, studentId) {
        this.onLinkClick(event, StudentDetailPageComponent.instance, studentId);
    }
    onCompanyLinkClick(event, companyId) {
        this.onLinkClick(event, CompanyDetailPageComponent.instance, companyId);
    }
    onJobLinkClick(event, jobId) {
        this.onLinkClick(event, JobDetailPageComponent.instance, jobId);
    }
    onLinkClick(event, detail, id) {
        event.stopPropagation();
        detail.referenceId = id;
        detail.open();
    }
    buildConfirmInterviewInfoUpdateRequest(progress, progressObj) {
        return {
            type: progress.type,
            hasInterview: progress.hasInterview,
            n: progress.n,
            seminarType: progressObj.progressSeminarType,
            seminarAt: progressObj.progressSeminarAt,
            isStudentDelay: progress.isStudentDelay,
            action: progress.status === ProgressStatusCode.セミナー確認中
                ? 82
                : 112,
            seminarAtMailSendFlag: 0
        };
    }
    buildSendInterviewInfoUpdateRequest(progress, progressObj) {
        const isSettingSeminar = progress.status === ProgressStatusCode.セミナー設定中;
        const isSemiOrFinalInterview = [
            SEMINAR_TYPE.SEMI_FINAL_INTERVIEW,
            SEMINAR_TYPE.FINAL_INTERVIEW
        ].includes(progressObj.progressSeminarType);
        return {
            type: progress.type,
            hasInterview: progress.hasInterview,
            n: isSettingSeminar && isSemiOrFinalInterview
                ? progress.n + 1
                : progress.n,
            seminarType: progressObj.progressSeminarType === SEMINAR_TYPE.INTERVIEW &&
                progressObj.progressStatus === ProgressStatusCode.セミナー設定中
                ? SEMINAR_TYPE.SEMINAR
                : progressObj.progressSeminarType,
            seminarAt: progressObj.progressSeminarAt,
            isStudentDelay: progress.isStudentDelay,
            action: isSettingSeminar &&
                progressObj.progressSeminarType === SEMINAR_TYPE.INTERVIEW
                ? PROGRESS_ACTION_CODES.SEND_SEMINAR_INVITATION
                : isSettingSeminar && isSemiOrFinalInterview
                    ? PROGRESS_ACTION_CODES.SEND_SEMI_OR_FINAL_SEMINAR_INVITATION
                    : progress.status === ProgressStatusCode.面接設定中
                        ? PROGRESS_ACTION_CODES.SEND_INTERVIEW_INVITATION
                        : null,
            seminarAtMailSendFlag: 0
        };
    }
    computeCanBulkEdit() {
        this.canBulkEdit = this.checkCanBulkEdit();
    }
    /**
     * 進捗サブステータス表示判定
     */
    needShowProgressSubScreeningStatusLabel(progress) {
        return this.getFirstProgressSubScreeningStatus(progress) != null;
    }
    needShowStartSubScreeningButton(progress) {
        return (_.isArray(progress.jobScreeningInfoList) &&
            progress.jobScreeningInfoList.length > 0 &&
            this.getFirstProgressSubScreeningStatus(progress) == null);
    }
    openStartSubScreeningProcessDialog(progress) {
        const dialogRef = this.dialog.open(ProgressSubScreeningStartDialogComponent, {
            data: {
                progress: progress
            }
        });
        const dialogCloseSubscription = dialogRef.afterClosed.subscribe(res => {
            if (res && res.saved) {
                this.refreshData(true, true);
            }
            dialogCloseSubscription.unsubscribe();
        });
    }
    openSendMainScreeningRequestMailDialog(progress) {
        const dialogRef = this.dialog.open(ProgressScreeningRequestNotifyDialogComponent, {
            data: { progress: progress }
        });
        const dialogCloseSubscription = dialogRef.afterClosed.subscribe(res => {
            if (res && res.saved) {
                this.refreshData(true, true);
            }
            dialogCloseSubscription.unsubscribe();
        });
    }
    openSendSubScreeningRequestMailDialog(progress, subStatus) {
        const dialogRef = this.dialog.open(ProgressSubScreeningRequestNotifyDialogComponent, {
            data: {
                progress: progress,
                progressSubScreeningStatus: subStatus,
                jobScreeningInfo: subStatus.jobScreeningInfo
            }
        });
        const dialogCloseSubscription = dialogRef.afterClosed.subscribe(res => {
            if (res && res.saved) {
                this.refreshData(true, true);
            }
            dialogCloseSubscription.unsubscribe();
        });
    }
    getCurrentSubScreeningProcessData(progress) {
        const subStatus = this.getFirstProgressSubScreeningStatus(progress);
        if (!subStatus) {
            return {
                raw: null,
                typeLabel: "",
                statusLabel: "",
                nextActionsGroups: [],
                scheduledAtDisplayValue: "",
            };
        }
        const typeLabel = subStatus.jobScreeningInfo && subStatus.jobScreeningInfo.type;
        const currentStatusCode = subStatus.status;
        const statusLabel = PROGRESS_SUB_SCREENING_STATUS_CODE_LABEL_MAPPING[currentStatusCode] || "";
        const hasRequestsToAnnounce = this.hasProgressSubScreeningRequests(subStatus, subStatus.jobScreeningInfo);
        const adjustSchedule = {
            label: `${typeLabel}日程調整`,
            btnColor: `green`,
            onClick: (targetProgress) => {
                this.openSubScreeningScheduleAdjustDialog(targetProgress, subStatus);
            }
        };
        const decideSchedule = {
            label: `${typeLabel}日時決定`,
            btnColor: 'blue',
            onClick: (targetProgress) => {
                this.openSubScreeningScheduleEditor(targetProgress);
            }
        };
        const decline = {
            label: `${typeLabel}辞退`,
            btnColor: `gray`,
            onClick: (targetProgress) => {
                this.updateProgressSubScreeningStatus(targetProgress, ProgressSubScreeningStatusCodes.辞退);
            },
        };
        const confirmSchedule = {
            label: `${typeLabel}確認済み`,
            btnColor: 'blue',
            onClick: (targetProgress) => {
                this.updateProgressSubScreeningStatus(targetProgress, ProgressSubScreeningStatusCodes.結果待ち);
            }
        };
        const complete = {
            label: `${typeLabel}完了`,
            btnColor: 'substatus',
            onClick: (targetProgress) => {
                this.updateProgressSubScreeningStatus(targetProgress, ProgressSubScreeningStatusCodes.完了);
            }
        };
        const announceScreeningRequests = {
            label: `${typeLabel}対応事項案内`,
            btnColor: 'green',
            onClick: (targetProgress) => {
                this.openSendSubScreeningRequestMailDialog(targetProgress, subStatus);
            }
        };
        const statusNextActionsGroups = {
            [ProgressSubScreeningStatusCodes.設定中]: [
                [
                    Object.assign({}, adjustSchedule, { withBorderRight: true }),
                    decideSchedule,
                    decline,
                ], [
                    complete,
                    ...(hasRequestsToAnnounce ? [
                        announceScreeningRequests
                    ] : []),
                ]
            ],
            [ProgressSubScreeningStatusCodes.確認中]: [
                [
                    confirmSchedule,
                    decline,
                ], [
                    complete,
                    ...(hasRequestsToAnnounce ? [
                        announceScreeningRequests
                    ] : []),
                ]
            ],
            [ProgressSubScreeningStatusCodes.結果待ち]: [
                [decline],
                [
                    complete,
                    ...(hasRequestsToAnnounce ? [
                        announceScreeningRequests
                    ] : [])
                ],
            ],
        };
        const shouldDisplayDate = subStatus.status === ProgressSubScreeningStatusCodes.確認中
            || subStatus.status === ProgressSubScreeningStatusCodes.結果待ち;
        const hasScheduleAt = subStatus.scheduledAt !== undefined
            && subStatus.scheduledAt !== null
            && subStatus.scheduledAt !== '';
        const scheduledAtDisplayValue = (shouldDisplayDate && hasScheduleAt)
            ? this.datePipe.transform(subStatus.scheduledAt, "yyyy/MM/dd (E) HH:mm")
            : '';
        return {
            raw: subStatus,
            typeLabel: typeLabel,
            statusLabel: `${typeLabel}${statusLabel}`,
            nextActionsGroups: statusNextActionsGroups[currentStatusCode] || [],
            scheduledAtDisplayValue
        };
    }
    hasProgressSubScreeningRequests(subStatus, jobScreeningInfo) {
        if (!subStatus) {
            return false;
        }
        const info = jobScreeningInfo || subStatus.jobScreeningInfo;
        if (!info) {
            return false;
        }
        const hasRequest = (value) => {
            if (typeof value === 'string') {
                return value.trim().length > 0;
            }
            return !!value;
        };
        return [info.request1, info.request2, info.request3].some(hasRequest);
    }
    getFirstProgressSubScreeningStatus(progress) {
        const subStatuses = progress.progressSubScreeningStatuses;
        if (!Array.isArray(subStatuses) || subStatuses.length === 0) {
            return null;
        }
        const firstNotCompleted = subStatuses.find(status => status &&
            ![
                ProgressSubScreeningStatusCodes.完了,
                ProgressSubScreeningStatusCodes.辞退,
            ].includes(status.status));
        return firstNotCompleted || null;
    }
    updateProgressSubScreeningStatus(progress, nextStatus) {
        if (!progress || !progress.id) {
            return;
        }
        const subStatus = this.getFirstProgressSubScreeningStatus(progress);
        if (!subStatus || !subStatus.id) {
            return;
        }
        const payload = {
            status: nextStatus,
            revision: subStatus.revision,
            mainStatus: progress.status,
            mainN: progress.n,
            jobScreeningInfoId: subStatus.jobScreeningInfoId,
        };
        const updateSubscription = this.progressApiService
            .updateProgressSubScreening(progress.id, subStatus.id, payload)
            .subscribe(() => {
            this.refreshData(true, true);
            this.progressApiService.refreshEvent.emit();
            updateSubscription.unsubscribe();
        });
    }
    openSubScreeningScheduleAdjustDialog(progress, subStatus) {
        if (!progress) {
            return;
        }
        let enterpriseId = progress.enterpriseId;
        if (enterpriseId == null && progress.enterprise) {
            enterpriseId = progress.enterprise.id;
        }
        const dialogRef = this.dialog.open(ProgressSubScreeningScheduleAdjustDialogComponent, {
            data: {
                title: `${subStatus.jobScreeningInfo.type} 日程調整送信`,
                studentIds: [progress.studentId],
                jobId: progress.jobId,
                progressType: progress.type,
                enterpriseId: enterpriseId,
                progress: progress,
                progressSubScreeningStatus: subStatus,
                jobScreeningInfo: subStatus.jobScreeningInfo
            }
        });
        const dialogCloseSubscription = dialogRef.afterClosed.subscribe(res => {
            if (res) {
                this.refreshData(true, true);
            }
            dialogCloseSubscription.unsubscribe();
        });
    }
    /**
     * 対応事項管理が有効な進捗フローであるかを判定する
     * - 以下のいずれかに当てはまる場合は有効
     *   - 管理フラグが有効「1」である
     *   - すでにDBの実レコードが紐付いている
     *   - セミナー設定中(70)〜面接結果待ち(120)の範囲
     */
    isManagementMode(progress) {
        if (!progress) {
            return false;
        }
        return ((progress.dynamicData && progress.dynamicData['screeningRequestsManagementEnabled'] == 1) ||
            (Array.isArray(progress.progressScreeningRequestStatuses) && progress.progressScreeningRequestStatuses.length > 0) ||
            (progress.status >= 70 && progress.status <= 120));
    }
    getMainScreeningRequests(progress) {
        if (!progress) {
            return [];
        }
        if (this.isManagementMode(progress)) {
            return this.getMainScreeningRequestsFromRequestStatusRecords(progress, progress.progressScreeningRequestStatuses);
        }
        return [];
    }
    getMainScreeningRequestsFromDynamicData(progress) {
        const targetInfo = this.getTargetInfoFromProgress(progress);
        const currentPhase = this.getCurrentMainPhaseName(progress);
        const completed = progress.dynamicData &&
            !!progress.dynamicData['correspondenceState'];
        if (!targetInfo || !currentPhase) {
            return [];
        }
        return this.getMainScreeningRequestsFromRequestStatusRecords(progress, [
            ...(targetInfo.request1 ? [{
                    progressId: progress.id,
                    requestStatus: completed
                        ? ProgressScreeningRequestStatusRequestStatusEnum.completed
                        : ProgressScreeningRequestStatusRequestStatusEnum.notHandledYet,
                    requestNo: ProgressScreeningRequestStatusRequestNoEnum.actionItem1,
                    requestType: currentPhase,
                    jobScreeningInfo: Object.assign({}, targetInfo)
                }] : []),
            ...(targetInfo.request2 ? [{
                    progressId: progress.id,
                    requestStatus: completed
                        ? ProgressScreeningRequestStatusRequestStatusEnum.completed
                        : ProgressScreeningRequestStatusRequestStatusEnum.notHandledYet,
                    requestNo: ProgressScreeningRequestStatusRequestNoEnum.actionItem2,
                    requestType: currentPhase,
                    jobScreeningInfo: Object.assign({}, targetInfo)
                }] : []),
            ...(targetInfo.request3 ? [{
                    progressId: progress.id,
                    requestStatus: completed
                        ? ProgressScreeningRequestStatusRequestStatusEnum.completed
                        : ProgressScreeningRequestStatusRequestStatusEnum.notHandledYet,
                    requestNo: ProgressScreeningRequestStatusRequestNoEnum.actionItem3,
                    requestType: currentPhase,
                    jobScreeningInfo: Object.assign({}, targetInfo)
                }] : []),
        ]);
    }
    getMainScreeningRequestsFromRequestStatusRecords(progress, progressScreeningRequestStatuses) {
        const currentPhase = this.getCurrentMainPhaseName(progress);
        if (!currentPhase) {
            return [];
        }
        const statuses = Array.isArray(progressScreeningRequestStatuses)
            ? progressScreeningRequestStatuses
            : [];
        return statuses.filter((s) => {
            return (!s.jobScreeningInfoId &&
                s.requestType === currentPhase &&
                (s.requestStatus === ProgressScreeningRequestStatusRequestStatusEnum.notInformedYet ||
                    s.requestStatus === ProgressScreeningRequestStatusRequestStatusEnum.notHandledYet));
        });
    }
    getSubScreeningRequests(progress) {
        if (!progress || !progress.progressScreeningRequestStatuses) {
            return [];
        }
        if (this.isManagementMode(progress)) {
            const activeSubStatus = this.getFirstProgressSubScreeningStatus(progress);
            if (!activeSubStatus) {
                return [];
            }
            return progress.progressScreeningRequestStatuses.filter((s) => {
                return (s.progressSubScreeningStatusId === activeSubStatus.id &&
                    (s.requestStatus === ProgressScreeningRequestStatusRequestStatusEnum.notInformedYet ||
                        s.requestStatus === ProgressScreeningRequestStatusRequestStatusEnum.notHandledYet));
            });
        }
        else {
            return [];
        }
    }
    needShowSendMainScreeningRequestMailButton(progress, mainRequests) {
        if (!progress) {
            return false;
        }
        const status = progress.status;
        const isMainScreeningPhaseStatus = status === ProgressStatusCode.セミナー設定中 ||
            status === ProgressStatusCode.セミナー確認中 ||
            status === ProgressStatusCode.セミナー結果待ち ||
            status === ProgressStatusCode.面接設定中 ||
            status === ProgressStatusCode.面接確認中 ||
            status === ProgressStatusCode.面接結果待ち;
        if (!isMainScreeningPhaseStatus) {
            return false;
        }
        const targetInfo = this.getTargetInfoFromProgress(progress);
        if (!targetInfo) {
            return false;
        }
        return !!(targetInfo.request1 || targetInfo.request2 || targetInfo.request3);
    }
    getMainScreeningRequestTypeLabel(progress, mainRequests) {
        return this.getCurrentMainPhaseName(progress) || '';
    }
    getCurrentMainPhaseName(progress) {
        const status = progress.status;
        if (status >= 70 && status <= 90) {
            return 'セミナー';
        }
        if (status >= 100 && status <= 120) {
            return getSeminarTypeLabel('面接', progress.seminarType, progress.n);
        }
        return null;
    }
    getRequestContent(progress, statusItem) {
        const targetInfo = this.getTargetInfo(progress, statusItem);
        if (!targetInfo)
            return '-';
        return targetInfo[`request${statusItem.requestNo}`] || '-';
    }
    getRequestDeadline(progress, statusItem) {
        if (statusItem.requestStatus === ProgressScreeningRequestStatusRequestStatusEnum.completed) {
            return '対応済み';
        }
        if (statusItem.requestDeadline) {
            const deadlineMoment = moment(statusItem.requestDeadline).utcOffset(9).startOf('day').locale('ja');
            const today = moment().utcOffset(9).startOf('day');
            const dateStr = deadlineMoment.format("YYYY/MM/DD(ddd)");
            if (deadlineMoment.isBefore(today)) {
                return `${dateStr}まで\n(期限日超過)`;
            }
            else {
                const remainingDays = this.calcRemainingBusinessDays(deadlineMoment);
                return `${dateStr}まで\n(残り${remainingDays}営業日)`;
            }
        }
        const targetInfo = this.getTargetInfo(progress, statusItem);
        if (!targetInfo)
            return '-';
        const deadlineValue = targetInfo[`request${statusItem.requestNo}Deadline` || ""];
        const option = SCREENING_INFO_REQUEST_DEADLINE_OPTIONS.find(o => o.value === deadlineValue);
        return option ? option.label : '-';
    }
    calcRemainingBusinessDays(deadline) {
        let count = 0;
        const current = moment().utcOffset(9).startOf("day");
        const target = deadline.clone().startOf("day");
        if (target.isSameOrBefore(current)) {
            return 0;
        }
        const tempDate = current.clone();
        // 今日から期限日までをループ
        while (tempDate.isBefore(target)) {
            tempDate.add(1, "days");
            // 土日(0=日, 6=土)を除外
            if (tempDate.day() !== 0 && tempDate.day() !== 6) {
                count++;
            }
        }
        return count;
    }
    getTargetInfoFromProgress(progress) {
        const job = progress.job;
        if (!job || !job.dynamicData) {
            return null;
        }
        const dynamicData = job.dynamicData;
        let n = progress.n;
        if (n && n > 5) {
            n = 5;
        }
        switch (progress.seminarType) {
            case SEMINAR_TYPE.SEMINAR: //セミナー
                return dynamicData.screeningInfoSeminar;
            case SEMINAR_TYPE.INTERVIEW: //面接
                return dynamicData[`screeningInfo${n}`];
            case SEMINAR_TYPE.SEMI_FINAL_INTERVIEW: //面接
                return dynamicData[`screeningInfo${n}`];
            case SEMINAR_TYPE.FINAL_INTERVIEW: //面接
                return dynamicData[`screeningInfo${n}`];
        }
        return null;
    }
    getTargetInfo(progress, statusItem) {
        if (!statusItem) {
            return null;
        }
        if (statusItem.jobScreeningInfo) {
            return statusItem.jobScreeningInfo;
        }
        const job = progress.job;
        if (!job || !job.dynamicData) {
            return null;
        }
        const type = statusItem.requestType || '';
        const dynamicData = job.dynamicData;
        if (type === 'セミナー') {
            return dynamicData.screeningInfoSeminar;
        }
        else if (type.includes('面接')) {
            const match = type.match(/(\d+)次/);
            let n = match ? match[1] : progress.n;
            if (Number(n) > 5) {
                n = 5;
            }
            return dynamicData[`screeningInfo${n}`];
        }
        return null;
    }
    toggleAlertDropdown(progressId, type, event) {
        event.stopPropagation();
        const currentKey = `${progressId}_${type}`;
        const otherType = type === 'main' ? 'sub' : 'main';
        const otherKey = `${progressId}_${otherType}`;
        const isOpening = !this.alertDropdownStates[currentKey];
        if (isOpening) {
            this.alertDropdownStates[otherKey] = false;
            this.alertDropdownStates[currentKey] = true;
        }
        else {
            this.alertDropdownStates[currentKey] = false;
        }
    }
    onCompleteRequestClick(progress, requestItem, event) {
        event.stopPropagation();
        const config = {
            title: '対応事項完了',
            messages: ['この対応事項を完了にしてもよろしいですか？'],
            buttons: { no: 'キャンセル', yes: '完了' }
        };
        this.dialog.open(ConfirmDialogComponent, config, (result) => {
            if (result) {
                const payload = Object.assign({}, requestItem, { requestStatus: ProgressScreeningRequestStatusRequestStatusEnum.completed, requestCompletedAt: moment().toDate() });
                this.progressApiService
                    .updateProgressScreeningRequestStatus(requestItem.id, progress.id, payload)
                    .subscribe(() => {
                    this.progressApiService.refreshEvent.emit();
                });
            }
        });
    }
    subScreeningDateEditing(progress) {
        if (this.eventEditors[progress.id] && this.editorMeta[progress.id]) {
            return false;
        }
        const progressSubScreeningStatus = this.getFirstProgressSubScreeningStatus(progress);
        if (!progressSubScreeningStatus) {
            return false;
        }
        return !!this.subStatusEditorMeta[progressSubScreeningStatus.id] &&
            !!this.subStatusEventEditors[progressSubScreeningStatus.id];
    }
    subScreeningEditorMeta(progress) {
        if (this.eventEditors[progress.id] && this.editorMeta[progress.id]) {
            return null;
        }
        const progressSubScreeningStatus = this.getFirstProgressSubScreeningStatus(progress);
        if (!progressSubScreeningStatus) {
            return null;
        }
        return this.subStatusEditorMeta[progressSubScreeningStatus.id];
    }
    subScreeningEventEditor(progress) {
        if (this.eventEditors[progress.id] && this.editorMeta[progress.id]) {
            return null;
        }
        const progressSubScreeningStatus = this.getFirstProgressSubScreeningStatus(progress);
        if (!progressSubScreeningStatus) {
            return null;
        }
        return this.subStatusEventEditors[progressSubScreeningStatus.id];
    }
    openSubScreeningScheduleEditor(progress) {
        if (this.eventEditors[progress.id] && this.editorMeta[progress.id]) {
            this.onCancelClick(progress.id);
            return;
        }
        const progressSubScreeningStatus = this.getFirstProgressSubScreeningStatus(progress);
        if (!progressSubScreeningStatus) {
            return;
        }
        this.subStatusEditorMeta[progressSubScreeningStatus.id] = deepClone(this.baseSubStatusEditorMeta);
        this.subStatusEventEditors[progressSubScreeningStatus.id] = {
            scheduledAt: this.datePipe.transform(new Date(), "yyyy/MM/dd"),
            skipSendScheduledAtMail: false,
            inSave: false
        };
    }
    onSubStatusCancelClick(progress) {
        const progressSubScreeningStatus = this.getFirstProgressSubScreeningStatus(progress);
        if (!progressSubScreeningStatus)
            return;
        if (this.subStatusEventEditors[progressSubScreeningStatus.id]) {
            delete this.subStatusEventEditors[progressSubScreeningStatus.id];
        }
    }
    onSubStatusSaveClick(progress) {
        const progressSubScreeningStatus = this.getFirstProgressSubScreeningStatus(progress);
        if (!progressSubScreeningStatus)
            return;
        if (this.subStatusEventEditors[progressSubScreeningStatus.id] &&
            this.subStatusEventEditors[progressSubScreeningStatus.id].inSave) {
            return;
        }
        let eventRequestObject = null;
        let eventRequest = null;
        const requestObject = {
            updatedStatus: ProgressSubScreeningStatusCodes.確認中,
        };
        if (this.subStatusEventEditors[progressSubScreeningStatus.id]) {
            this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = true;
            const event = this.subStatusEventEditors[progressSubScreeningStatus.id];
            if (event.scheduledAt) {
                const scheduledAtStr = new Date(event.scheduledAt).toAsialDateTimeString();
                eventRequestObject = Object.assign({}, requestObject, {
                    scheduledAt: scheduledAtStr,
                    scheduledAtMailSendFlag: event.skipSendScheduledAtMail ? 0 : 1
                });
                eventRequest = this.progressApiService.updateProgressScreeningRequestStatusWithAction(progressSubScreeningStatus.progressId, progressSubScreeningStatus.id, eventRequestObject).pipe(concatMap(() => {
                    return this.progressApiService.updateSubScreeningRequestDeadlines(progressSubScreeningStatus.progressId, progressSubScreeningStatus.id, scheduledAtStr, progressSubScreeningStatus.jobScreeningInfoId);
                }));
            }
            if (!event.skipSendScheduledAtMail) {
                const scheduledAtReplacementValue = event.scheduledAt
                    ? this.datePipe.transform(new Date(event.scheduledAt).toAsialDateTimeString(), "yyyy年M月d日 HH時mm分")
                    : "";
                this.progressApiService.getStakeholders([progressSubScreeningStatus.progressId]).subscribe((stakeholders) => {
                    const stakeholder = stakeholders && stakeholders.length ? stakeholders[0] : null;
                    if (stakeholders &&
                        stakeholder.studentInfo.mainAvailable === "不可") {
                        PopupControlComponent.instance.open({
                            title: "エラー",
                            content: "E-MAIL(メイン)が「送信不可」です。",
                            confirmText: "閉じる",
                            confirmCallback: () => {
                                this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
                            }
                        });
                    }
                    else if (stakeholder) {
                        this.mailApiService
                            .getMailTemplates()
                            .pipe(map((templates) => templates.find(template => template.systemName === 'student_confirm_sub_screening')))
                            .subscribe((template) => {
                            if (template) {
                                const mailRequestObject = {
                                    to: stakeholder.studentInfo.mainAvailable !== "不可"
                                        ? [stakeholder.studentInfo.main]
                                        : null,
                                    cc: [
                                        stakeholder.studentInfo.subAvailable !== "不可"
                                            ? stakeholder.studentInfo.sub
                                            : null,
                                        ...stakeholder.jobUsersInfo
                                            .filter(jobUser => jobUser.type === 0)
                                            .map(jobUser => jobUser.email)
                                    ].filter(v => v),
                                    bcc: [
                                        ...stakeholder.jobUsersInfo
                                            .filter(jobUser => jobUser.type ===
                                            (progress.type === 0
                                                ? EnterpriseDepartmentUserType.RA
                                                : progress.type === 1
                                                    ? EnterpriseDepartmentUserType.PA
                                                    : -1))
                                            .map(jobUser => jobUser.email)
                                    ].filter(v => v),
                                    userId: this.authService.loginUser.id,
                                    from: this.authService.loginUser.email,
                                    subject: template.subject,
                                    text: template.body,
                                    templateTypeId: template.mailTemplateTypeId,
                                    jobId: progress.jobId
                                };
                                const mailRequest = this.mailApiService
                                    .replaceTemplate(mailRequestObject.templateTypeId, {
                                    from: mailRequestObject.from,
                                    to: mailRequestObject.to,
                                    subject: mailRequestObject.subject,
                                    text: mailRequestObject.text,
                                    studentId: progress.studentId,
                                    jobId: progress.jobId,
                                    progress,
                                    additionalReplacements: [
                                        {
                                            label: "面接日時",
                                            value: scheduledAtReplacementValue,
                                        },
                                        {
                                            label: "サブステータス-選考名",
                                            value: String((progressSubScreeningStatus &&
                                                progressSubScreeningStatus.jobScreeningInfo &&
                                                progressSubScreeningStatus.jobScreeningInfo.type) ||
                                                "")
                                                .replace(/[\r\n]+/g, "")
                                                .trim(),
                                            withoutAppendingNewline: true,
                                        },
                                        {
                                            label: '会場名',
                                            value: formatTemplateMultilineValue(progressSubScreeningStatus &&
                                                progressSubScreeningStatus.jobScreeningInfo &&
                                                progressSubScreeningStatus.jobScreeningInfo.location),
                                            withoutAppendingNewline: true,
                                        },
                                        {
                                            label: '会場住所',
                                            value: formatTemplateMultilineValue(progressSubScreeningStatus &&
                                                progressSubScreeningStatus.jobScreeningInfo &&
                                                progressSubScreeningStatus.jobScreeningInfo.address),
                                            withoutAppendingNewline: true,
                                        },
                                        {
                                            label: '会場最寄駅',
                                            value: formatTemplateMultilineValue(progressSubScreeningStatus &&
                                                progressSubScreeningStatus.jobScreeningInfo &&
                                                progressSubScreeningStatus.jobScreeningInfo.nearestStation),
                                            withoutAppendingNewline: true,
                                        },
                                        {
                                            label: '所要時間',
                                            value: formatTemplateMultilineValue(progressSubScreeningStatus &&
                                                progressSubScreeningStatus.jobScreeningInfo &&
                                                progressSubScreeningStatus.jobScreeningInfo.duration),
                                            withoutAppendingNewline: true,
                                        },
                                        {
                                            label: '持参物',
                                            value: formatTemplateMultilineValue(progressSubScreeningStatus &&
                                                progressSubScreeningStatus.jobScreeningInfo &&
                                                progressSubScreeningStatus.jobScreeningInfo.preparation),
                                            withoutAppendingNewline: true,
                                        },
                                        {
                                            label: '緊急連絡先',
                                            value: formatTemplateMultilineValue(progressSubScreeningStatus &&
                                                progressSubScreeningStatus.jobScreeningInfo &&
                                                progressSubScreeningStatus.jobScreeningInfo.emergencyContact),
                                            withoutAppendingNewline: true,
                                        },
                                    ],
                                })
                                    .pipe(mergeMap(res => {
                                    mailRequestObject.subject = res.subject;
                                    mailRequestObject.text = res.body;
                                    return this.mailApiService.sendStudentMail(progress.studentId, mailRequestObject);
                                }));
                                eventRequest = eventRequest.pipe(mergeMap(() => mailRequest));
                                /* node 22 対応 */
                                this.doMailSubscribe(eventRequest);
                                setTimeout(() => {
                                    this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
                                    this.onSubStatusCancelClick(progress);
                                    PopupControlComponent.instance.open({
                                        title: "メール送信処理開始",
                                        content: "メール送信処理を開始しました。\nしばらく経ってからメール管理画面へ反映されます。\n\nもしメール送信が失敗した場合、メール送信失敗メールが届きます。",
                                        confirmText: "OK",
                                        confirmCallback: () => false
                                    });
                                    CacheInterceptor.requestCountChange.emit(0);
                                }, 10);
                                setTimeout(() => {
                                    CacheInterceptor.requestCountChange.emit(0);
                                }, 1000);
                            }
                            else {
                                this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
                            }
                        }, () => {
                            this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
                        });
                    }
                    else {
                        this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
                    }
                }, () => {
                    this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
                });
            }
            else if (eventRequest) {
                eventRequest.subscribe(() => {
                    this.progressApiService.refreshEvent.emit();
                    this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
                    this.onSubStatusCancelClick(progress);
                });
            }
            else {
                this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
            }
        }
    }
    onSubStatusMailActionClick(progress, mailConfig) {
        if (!mailConfig) {
            return;
        }
        const progressSubScreeningStatus = this.getFirstProgressSubScreeningStatus(progress);
        if (!progressSubScreeningStatus)
            return;
        const mailConfigInstance = new mailConfig();
        const progressObj = {};
        const event = this.subStatusEventEditors[progressSubScreeningStatus.id];
        if (progressSubScreeningStatus) {
            if (event) {
                progressObj.progressScheduledAt = new Date(event.scheduledAt).toAsialDateTimeString();
            }
            progressObj.progress = progress;
            progressObj.progressSubScreeningStatus = progressSubScreeningStatus;
        }
        if (mailConfigInstance instanceof ProgressSendSubScreeningInfoConfig) {
            this.progressApiService
                .getStakeholders([progress.id])
                .subscribe((stakeholders) => {
                if (stakeholders.length) {
                    MailSendFlowComponent.instance.config = mailConfigInstance;
                    mailConfigInstance.setParams(Object.assign({ stakeholders: stakeholders[0], progressType: progress.type, studentId: progress.studentId, jobId: progress.jobId, enterpriseId: progress.enterprise.id }, progressObj));
                    MailSendFlowComponent.instance.start({
                        additionalReplacements: [
                            {
                                label: 'サブステータス-選考名',
                                value: progressSubScreeningStatus.jobScreeningInfo.type,
                                withoutAppendingNewline: true,
                            }, {
                                label: '面接日時',
                                value: this.datePipe.transform(new Date(event.scheduledAt).toAsialDateTimeString(), 'yyyy年M月d日 HH時mm分'),
                            }
                        ]
                    });
                    if ([
                        ProgressSubScreeningStatusCodes.設定中,
                    ].includes(progressSubScreeningStatus.status)) {
                        const scheduledAtStr = new Date(event.scheduledAt).toAsialDateTimeString();
                        const sub = MailSendFlowComponent.instance.sent.subscribe(() => {
                            this.progressApiService
                                .updateProgressScreeningRequestStatusWithAction(progress.id, progressSubScreeningStatus.id, {
                                updatedStatus: ProgressSubScreeningStatusCodes.確認中,
                                scheduledAt: scheduledAtStr,
                                scheduledAtMailSendFlag: 0,
                            }).pipe(concatMap(() => this.progressApiService.updateSubScreeningRequestDeadlines(progress.id, progressSubScreeningStatus.id, progressObj.progressScheduledAt)))
                                .subscribe(() => {
                                this.progressApiService.refreshEvent.emit();
                                if (progress && this.eventEditors[progress.id]) {
                                    this.eventEditors[progress.id] = null;
                                }
                            });
                            sub.unsubscribe();
                        });
                        const closedSub = MailSendFlowComponent.instance.closed.subscribe(() => {
                            sub.unsubscribe();
                            closedSub.unsubscribe();
                        });
                    }
                }
            });
        }
    }
    computeCanSeminarScheduleLink() {
        this.canSeminarScheduleLink =
            this.enableSeminarScheduleLinkButton &&
                !!this.getMatchedSeminarScheduleList();
    }
    getMatchedSeminarScheduleList() {
        if (!this.hasCheckedItems) {
            return null;
        }
        const checkedItems = this.table.checkedItems;
        // 既にセミナースケジュール予約済みの進捗は対象外
        if (checkedItems.some(item => item.hasSeminarScheduleReservation)) {
            return null;
        }
        // 紐付け対象は「セミナー確認中 / セミナー結果待ち」のみ許可
        const hasValidStatus = checkedItems.every(item => item.status === ProgressStatusCode.セミナー確認中 ||
            item.status === ProgressStatusCode.セミナー結果待ち);
        if (!hasValidStatus) {
            return null;
        }
        // 1件選択時: 対象progressのseminarAtに一致するstartAtがschedule上に存在すること
        if (checkedItems.length === 1) {
            const item = checkedItems[0];
            const schedule = item &&
                item.job &&
                item.job.jobSettingSeminar &&
                item.job.jobSettingSeminar.schedule;
            if (!schedule || !schedule.length || !item.seminarAt) {
                return null;
            }
            const seminarAt = moment(item.seminarAt);
            const matched = schedule.filter(s => moment(s.startAt).isSame(seminarAt));
            return matched.length ? matched : null;
        }
        // 複数選択時: 同一求人(jobId)のprogressのみ紐付け可能
        const firstJobId = checkedItems[0].jobId;
        if (!checkedItems.every(item => item.jobId === firstJobId)) {
            return null;
        }
        // 複数選択時: seminarAtが全件同一であること
        const firstSeminarAt = checkedItems[0].seminarAt;
        if (!firstSeminarAt) {
            return null;
        }
        const seminarAt = moment(firstSeminarAt);
        if (!checkedItems.every(item => item.seminarAt && moment(item.seminarAt).isSame(seminarAt))) {
            return null;
        }
        // 同一seminarAtに一致するstartAtが、対象求人のscheduleに存在すること
        const firstItem = checkedItems[0];
        const schedule = firstItem &&
            firstItem.job &&
            firstItem.job.jobSettingSeminar &&
            firstItem.job.jobSettingSeminar.schedule;
        if (!schedule || !schedule.length) {
            return null;
        }
        const matched = schedule.filter(s => moment(s.startAt).isSame(seminarAt));
        return matched.length ? matched : null;
    }
}
